import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function AcceptancePanel({ projectName }) {
  const [checks, setChecks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [runResult, setRunResult] = useState(null);

  useEffect(() => {
    loadAcceptance();
  }, [projectName]);

  const loadAcceptance = async () => {
    try {
      const res = await axios.get(`/api/projects/${encodeURIComponent(projectName)}/acceptance`);
      const data = res.data?.checks || res.data || [];
      setChecks(Array.isArray(data) ? data : []);
    } catch (err) {
      console.warn('验收文件暂未接通:', err.message);
      setChecks([
        { id: 'CONST-01', module: '项目宪法', title: '存在 constitution.yaml', status: 'pending' },
        { id: 'ACC-01', module: '验收标准', title: '存在项目自己的 acceptance.yaml', status: 'pending' },
        { id: 'PIPE-01', module: '生产线', title: '检测→评审→补丁→回归→打包闭环', status: 'pending' }
      ]);
    }
  };

  const runAcceptance = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`/api/projects/${encodeURIComponent(projectName)}/test`);
      setRunResult(res.data);
    } catch (err) {
      setRunResult({
        error: true,
        message: '验收检测接口暂未接通或执行失败',
        detail: err.response?.data?.error || err.message
      });
    } finally {
      setLoading(false);
    }
  };

  const statusClass = (status) => {
    if (status === 'pass') return 'text-green-400';
    if (status === 'fail') return 'text-red-400';
    if (status === 'running') return 'text-yellow-400';
    return 'text-gray-400';
  };

  return (
    <div className="p-4 text-sm">
      <h3 className="font-bold mb-3">验收检测</h3>

      <div className="bg-gray-900 rounded p-3 mb-3 text-xs text-gray-300">
        每个项目必须有自己的验收标准。美业项目可以是59项，其他项目必须使用自己的验收文件。
      </div>

      <button
        onClick={runAcceptance}
        disabled={loading}
        className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-60 py-2 rounded mb-4"
      >
        {loading ? '检测中...' : '运行项目验收'}
      </button>

      <div className="space-y-2">
        {checks.map((item, index) => (
          <div key={item.id || index} className="bg-gray-900 rounded p-2">
            <div className="flex justify-between gap-2">
              <span className="font-semibold">{item.id || `CHECK-${index + 1}`}</span>
              <span className={statusClass(item.status)}>{String(item.status || 'pending').toUpperCase()}</span>
            </div>
            <div className="text-xs text-gray-300 mt-1">{item.module || '未分类'} / {item.title || item.requirement || '未命名验收项'}</div>
          </div>
        ))}
      </div>

      {runResult && (
        <pre className="bg-black text-green-400 p-3 rounded h-48 overflow-auto text-xs whitespace-pre-wrap mt-4">
          {JSON.stringify(runResult, null, 2)}
        </pre>
      )}
    </div>
  );
}
